import React from 'react';
import {
  Pencil,
  Trash2,
  Download,
  Upload,
  MoreVertical,
  Save,
  X,
  RefreshCcw,
  AlertTriangle,
  Plus,
  Eye
} from 'lucide-react';

export function EditButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-blue-100 text-blue-600 ${className || ''}`}
      title="Editar"
      onClick={onClick}
      type="button"
    >
      <Pencil size={18} />
    </button>
  );
}

export function DeleteButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-red-100 text-red-600 ${className || ''}`}
      title="Eliminar"
      onClick={onClick}
      type="button"
    >
      <Trash2 size={18} />
    </button>
  );
}

export function ExportButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-green-100 text-green-600 ${className || ''}`}
      title="Exportar"
      onClick={onClick}
      type="button"
    >
      <Download size={18} />
    </button>
  );
}

export function ImportButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-orange-100 text-orange-600 ${className || ''}`}
      title="Importar"
      onClick={onClick}
      type="button"
    >
      <Upload size={18} />
    </button>
  );
}

export function SaveButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-emerald-100 text-emerald-600 font-semibold ${className || ''}`}
      title="Guardar"
      onClick={onClick}
      type="button"
    >
      <Save size={18} />
    </button>
  );
}

export function CancelButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-gray-100 text-gray-500 font-semibold ${className || ''}`}
      title="Cancelar"
      onClick={onClick}
      type="button"
    >
      <X size={18} />
    </button>
  );
}

export function ResetButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-yellow-100 text-yellow-600 font-semibold ${className || ''}`}
      title="Restablecer"
      onClick={onClick}
      type="button"
    >
      <RefreshCcw size={18} />
    </button>
  );
}

export function AlertButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-red-100 text-red-600 font-semibold ${className || ''}`}
      title="Alerta"
      onClick={onClick}
      type="button"
    >
      <AlertTriangle size={18} />
    </button>
  );
}

export function CreateButton({ onClick, className, children }: { onClick?: () => void; className?: string; children?: React.ReactNode }) {
  return (
    <button
      className={`p-2 rounded hover:bg-blue-100 text-blue-600 font-semibold flex items-center gap-1 ${className || ''}`}
      title="Crear"
      onClick={onClick}
      type="button"
    >
      <Plus size={18} />
      {children || 'Crear'}
    </button>
  );
}

export function ViewButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-gray-100 text-gray-600 ${className || ''}`}
      title="Ver"
      onClick={onClick}
      type="button"
    >
      <Eye size={18} />
    </button>
  );
}

export function ActionButtonGroup({ children, ...props }: { children: React.ReactNode; [key: string]: any }) {
  return <div className="flex gap-1 items-center" {...props}>{children}</div>;
}

export function MoreButton({ onClick, className }: { onClick?: () => void; className?: string }) {
  return (
    <button
      className={`p-2 rounded hover:bg-gray-100 text-gray-600 ${className || ''}`}
      title="Más acciones"
      onClick={onClick}
      type="button"
    >
      <MoreVertical size={18} />
    </button>
  );
} 